/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ExtendedTooltipProps } from "@nordcloud/gnui/dist/components/extendedTooltip/ExtendedTooltip";
import { SvgName } from "~/tools/types";
import { ColumnType } from "~/types";

export function getSelectedOptions(
  selectedItems: string[],
  selectedItem: string
): string[] {
  return selectedItems.includes(selectedItem)
    ? selectedItems.filter((item) => item !== selectedItem)
    : [...selectedItems, selectedItem];
}

export function formatSidebarOptions(
  items: Array<{
    id?: string;
    name?: string;
    icon?: SvgName;
    iconTooltip?: string;
    iconTooltipPlacement?: ExtendedTooltipProps["placement"];
    color?: string;
  }>
) {
  return items.map((item) => ({
    label: item?.name ?? "",
    id: item?.id ?? "",
    columns: [
      {
        data: [item?.name ?? "", item?.id ?? ""],
        type: ColumnType.text,
      },
    ],
    icon: item.icon ?? undefined,
    iconTooltip: item.iconTooltip ?? undefined,
    iconTooltipPlacement: item.iconTooltipPlacement ?? "left",
    color: item.color,
  }));
}
